import i18n from 'i18next';
import Backend from 'i18next-chained-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import XHR from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import {getRouterBasename} from './app/utils/get-router-basename';

const routerBasename = getRouterBasename();

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      allowMultiLoading: true,
      backends: [
        LocalStorageBackend,
        XHR,
      ],
      backendOptions: [{
        prefix: 'i18next_CB_',
        expirationTime: 24*60*60*1000,
        defaultVersion: 'v1.90.0',
      }, {
        loadPath: `${routerBasename}/locales/{{lng}}/{{ns}}.json`,
      }],
    },
  });

export default i18n;
